var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "order-wrapper" },
    [
      !_vm.orderLink
        ? _c("order-creating", {
            attrs: {
              url: _vm.url,
              "employees-list-url": _vm.employeesListUrl,
              "services-list-url": _vm.servicesListUrl
            },
            on: { "order-created": _vm.orderCreated }
          })
        : _vm._e(),
      _vm.orderLink
        ? _c("order-response", { attrs: { "order-link": _vm.orderLink } })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0c843491", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0c843491","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/js/components/Order/Order.vue
// module id = 965
// module chunks = 0